<template>
  <span class="label-required"><slot /></span>
</template>

<script>
export default {
  name: 'ui-required',
  props: {
  },
  computed: {
    labelText () {
      if (!this.isVertical) {
        return this.label
      }
      return this.label.split('').join('<br />')
    }
  },
  methods: {
    onClick (e) {
      if (this.disabled) return
      this.$emit('click', e)
    }
  }
}
</script>
<style>
  .label-required::after{
    content: '*';
    color: #f56c6c;
    margin-left: 4px;
  }
</style>
